<template>
    <div v-if="url" class="btn-group mb-1" role="group">
        <a :href="url" type="button" class="btn btn-light pe-1" target="_blank">
            <code class="text-uppercase text-primary">{{ name }} ID</code> 
            <Badge color="light" class="ms-1">{{ value }}</Badge>
        </a>
        <Button class="ps-1 pe-2" color="light" v-clipboard:copy="`${value}`">
            <Badge color="light"><Icon icon="paste" class="text-secondary" /></Badge>
        </Button>
    </div>
    <Button v-else class="mb-1" color="light" v-clipboard:copy="`${value}`">
        <code class="text-uppercase">{{ name }} ID</code> <Badge color="light" class="ms-1">{{ value }}</Badge>
    </Button>
</template>

<script>
    import Badge from '../Badge'
    import Button from '../Button'
    import Icon from '../Icons/Icon'

    export default {
        name: 'ID',
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: [ String, Number ],
                required: true
            },
            url: String
        },
        components: {
            Badge,
            Button,
            Icon
        },
    }
</script>
